import { createListModalComponent } from 'factories/ListModal'
import Filter from 'containers/DashboardCharts/Select/Filter'

export default createListModalComponent({
  getStorageKey: (self) => 'selectDashboardChart',
  getSettingsType: (self) => 'selectDashboardChart',
})(Filter)
